class CurrentUserApiAdapter {
  constructor (restAdapter) {
    if (restAdapter) {
      this.restAdapter = restAdapter
    }
  }

  update (data) {
    return this.restAdapter.update('user/', data)
  }

  resetPassword (data) {
    return this.restAdapter.create('user/reset-password', data)
  }

  verifyOTP (data) {
    return this.restAdapter.create('user/verify-otp', data)
  }

  resendOTP (data) {
    return this.restAdapter.create('user/resend-otp', data)
  }

  changePassword (data) {
    return this.restAdapter.create('user/change-password', data)
  }

  activate (signupToken, data) {
    return this.restAdapter.create(`user/activate?signupToken=${signupToken}`, data)
  }

  checkToken (signupToken) {
    return this.restAdapter.get(`user/check-token?signupToken=${signupToken}`, {})
  }

  resendWelcomeEmail (email) {
    return this.restAdapter.create('signup/resend-activation-email', {email})
  }

  sendAccountSyncedEmail (data) {
    return this.restAdapter.create('user/send-account-synced-email', data)
  }

  sendUserMovedToClassicPAYGOnlyEmail (data) {
    return this.restAdapter.create('user/send-user-moved-to-classic-payg-only', data)
  }

  getUsersList (params) {
    return this.restAdapter.get('user/list', {...params})
  }

  getUser (user) {
    return this.restAdapter.get('user/get', { user })
  }

  sendVerificationCode (data) {
    return this.restAdapter.create('user/send-verification-code', data)
  }

  verifyCode (data) {
    return this.restAdapter.create('user/verify-code', data)
  }
}

module.exports = CurrentUserApiAdapter
